import React from 'react'
import { Section } from 'components'

function Error404() {
	return (
		<Section>
			<h1>Error 404</h1>
			<p>No content at this link :(</p>
		</Section>
	)
}

export default Error404
